<template>
  <div class="paySuc">
    <!-- <van-nav-bar title="支付成功"
                 left-arrow
                 @click-left="onClickLeft" /> -->
    <div class="paySuc-top">
      <p>
        <i class="van-icon van-icon-passed"></i>
        <span class='pay-suc'>订单支付成功</span>
        <span class='pay-style'>支付方式<span>{{this.payway}}</span></span>
        <span class='pay-mon'>支付金额<span>￥{{this.paysum}}</span></span>
      </p>
      <div class="btn">
        <router-link to="/orderList">
          <van-button size="normal">查看订单</van-button>
        </router-link>
        <router-link to="/home">
          <van-button size="normal">返回首页</van-button>
        </router-link>
      </div>
      <div class="msg">
        <span>温馨提示：</span>
        <span>智慧家不会以订单异常、系统升级为由要求您点击任何网址链接进行退款操作。</span>
      </div>
    </div>
  </div>
</template>

<script>

import store from '@/vuex/store'
import { mapState } from 'vuex'
import { Toast } from 'vant'
import { Dialog } from 'vant'
import { fdatasync } from 'fs';
//import {eventBus} from '../../assets/js/eventBus'

export default {
  store,
  data () {
    return {
      payway: '',
      paysum: ''
    }
  },
  created () {
    this.payway = this.$route.params.payway;
    this.paysum = this.$route.params.money;
  },
  mounted () {
    //原生调返回
    window['backToMy'] = () => {
      this.onClickLeft();
    }
  },
  methods: {
    onClickLeft () {
      this.$router.push('/my');
    }
  }
}
</script>

<style lang="less" >
.paySuc {
  .paySuc-top {
    padding: 0.98rem 5%;
    background: #fff;
    color: #333;
    p {
      padding: 0 0 0.5rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      & > i {
        width: 1.5rem !important;
        height: 1.5rem !important;
        background: url("../../../static/image/goods/splitPic/paySuccess/ios/successful.png")
          no-repeat center center;
        margin-bottom: 0.34rem;
      }

      span {
        display: inline-block;
      }
    }
    .msg {
      display: flex;
      flex-direction: column;
      padding: 0.2rem 0;
      h1 {
        font-size: 0.32rem;
      }
      span {
        font-size: 0.24rem;
        line-height: 0.32rem;
        color: rgb(102, 102, 102);
      }
    }
  }
  .btn {
    text-align: center;
    margin-bottom: 0.74rem;
  }

  .van-icon .van-icon-passed {
    width: 1.5rem !important;
    height: 1.5rem !important;
    background: url("../../../static/image/goods/splitPic/paySuccess/ios/successful.png")
      no-repeat center center;
  }
  .van-icon-passed:before {
    content: "";
  }
  .van-nav-bar__title {
    border-bottom: 1px solid #e5e5e5;
  }
  .pay-suc {
    font-size: 0.36rem;
    font-weight: bold;
    margin-bottom: 0.32rem;
  }
  .pay-style,
  .pay-mon {
    font-size: 0.24rem;
    color: #000;
    margin-bottom: 0.2rem;

    & > span {
      margin-left: 0.1rem;
      font-size: 0.28rem;
      color: rgb(255, 144, 0);
    }
  }

  .van-button--normal {
    width: 2.6rem;
    font-size: 14px;
    height: 0.88rem;
    border: 1px solid rgb(255, 144, 0);
    border-radius: 0.2rem;

    span {
      color: rgb(255, 144, 0);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/pay/pay_suc.vue